import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@lichtblick/photon/atoms/text/text';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import styles from './b2b-data-privacy-text.module.scss';
import { legalTextSnippets, marketingLegalTextSnippets } from './b2b-funnel-embed.content';
export const B2BAddressTooltipText = /*#__PURE__*/ _jsxs(Text, {
    className: styles.text,
    children: [
        "Ihre Unternehmensdaten helfen uns, regionale Gegebenheiten zu berücksichtigen und ein passendes Angebot zu erstellen.",
        /*#__PURE__*/ _jsx("br", {}),
        "Wir verarbeiten Ihre Daten ausschließlich zur Erstellung, Versand und Abstimmung Ihres Angebotes, sowie zur Kommunikation hierzu mit Ihnen. Weitere Informationen finden Sie in unseren",
        ' ',
        /*#__PURE__*/ _jsx(TextCTA, {
            as: "a",
            href: "/datenschutz/",
            inlineLink: true,
            slim: true,
            target: "_blank",
            children: "Datenschutzhinweisen"
        }),
        "."
    ]
});
export const B2BLegalConsentText = /*#__PURE__*/ _jsxs(Text, {
    className: styles['privacy-hint'],
    size: "s",
    children: [
        legalTextSnippets[0],
        /*#__PURE__*/ _jsx(TextCTA, {
            as: "a",
            href: "/datenschutz/",
            inlineLink: true,
            slim: true,
            target: "_blank",
            children: legalTextSnippets[1]
        }),
        legalTextSnippets[2]
    ]
});
export const B2BMarketingConsentText = /*#__PURE__*/ _jsxs(Text, {
    className: styles.text,
    size: "xs",
    children: [
        marketingLegalTextSnippets[0],
        /*#__PURE__*/ _jsx(TextCTA, {
            as: "a",
            href: "/lichtblick-gruppe/",
            inlineLink: true,
            slim: true,
            target: "_blank",
            children: marketingLegalTextSnippets[1]
        }),
        marketingLegalTextSnippets[2]
    ]
});

//# sourceMappingURL=b2b-data-privacy-text.js.map